import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";

const TermComponent = (props: any) => {
    const { termList, info } = props;

    const navigate = useNavigate();

    const { isApp } = useSelector((state: any) => state.common);
    return (
        <main className="terms">
            <div className="con">

                <div
                    onClick={() => {
                        navigate("/", { replace: true });
                    }}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "8px",
                        marginBottom: "16px"
                    }}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginRight: "4px" }}
                    >
                        <path
                            d="M15 18L9 12L15 6"
                            stroke="#333"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>


                {termList.length > 0 ? (
                    <div className="overflow-x-auto">
                        <ul className="flex gap-1 py-2 min-w-max">
                            {termList
                                ? termList.map((item: any, index: number) => (
                                    <li
                                        className={`flex-shrink-0 px-2 py-2 rounded-lg border transition-colors ${info?.id === item.id
                                            ? "bg-white border-gray-300"
                                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                                            }`}
                                        key={`term-${index}`}
                                    >
                                        <a
                                            className={`block cursor-pointer whitespace-nowrap text-sm ${info?.id === item.id
                                                ? "underline font-bold"
                                                : ""
                                                }`}
                                            style={info?.id === item.id ? { color: '#cf3688' } : {}}
                                            onClick={(e: any) => {
                                                e.preventDefault();
                                                navigate(`/term/common/${item?.id}`);
                                            }}>
                                            {item?.title}
                                        </a>
                                    </li>
                                ))
                                : null}
                        </ul>
                    </div>
                ) : null}

                <div className="content">
                    {info?.version >= 2 ? (
                        <ReactMarkdown>{info?.text || ""}</ReactMarkdown>
                    ) : (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: info?.text,
                            }}></div>
                    )}
                </div>
            </div>
        </main>
    );
};
export default TermComponent;
